export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/webflow.4adcf5e.svg";